import React, { useEffect, useRef, useState } from 'react';
import { Box } from '@material-ui/core';
import { emailIsValidRe, wait } from 'globals/utils';
import defaultLocales from 'globals/locales/default';
import FsSimpleInput from 'ui-elements/form-elements/FsDefaultInput';
import FsPendingButton from 'ui-elements/buttons/FsPendingButton';
import FsFormFullWidthContainer from 'ui-elements/form-elements/FsFormFullWidthContainer';
import FsNextArrowIcon from 'ui-elements/icons/FsNextArrow';

export interface FsRegisterInitialFormDataProps {
  email: string;
}

interface FsRegisterInitialFormProps extends FsRegisterInitialFormDataProps {
  onClose?: () => void;
  onGoNext?: (props: FsRegisterInitialFormDataProps) => void;
}

const FsRegisterInitialForm: React.FC<FsRegisterInitialFormProps> = ({
  onClose,
  onGoNext,
  ...defaults
}) => {
  const formEl = useRef<HTMLFormElement>(null);
  const [email, setEmail] = useState<string>(defaults.email);
  const [pending, setPending] = useState<boolean>(false);
  const [isFormValid, setIsFormValid] = useState<boolean>(false);

  const fields = [
    {
      required: true,
      name: defaultLocales.email.toLowerCase(),
      value: email,
      label: defaultLocales.email,
      onChange: (e: React.ChangeEvent<HTMLInputElement>): void => {
        setEmail(e.target?.value);
      },
      autoFocus: true,
    },
  ];

  const handleSubmit = async (e: React.FormEvent): Promise<void> => {
    e.preventDefault();
    setPending(true);
    // eslint-disable-next-line no-console
    console.log('Save changes', {
      email,
    });
    await wait(1000);
    setPending(false);
    if (onClose) onClose();
    if (onGoNext) onGoNext({ email });
  };

  useEffect(() => {
    const isDefaultFormValid = !!formEl?.current?.checkValidity();
    const isEmailValid = !!email.match(emailIsValidRe);
    setIsFormValid(isDefaultFormValid && isEmailValid);
  }, [email]);

  return (
    <Box>
      <form onSubmit={handleSubmit} ref={formEl}>
        {fields.map(({ name, ...otherProps }) => (
          <FsFormFullWidthContainer key={name}>
            <FsSimpleInput
              {...{ ...otherProps, name }}
              fsVariant="outlined"
              fullWidth
            />
          </FsFormFullWidthContainer>
        ))}
        <FsPendingButton
          type="submit"
          variant="contained"
          color="primary"
          pending={pending}
          disabled={!isFormValid}
          endIcon={<FsNextArrowIcon />}
          fullWidth
          spaceBetween
        >
          {defaultLocales.continue}
        </FsPendingButton>
      </form>
    </Box>
  );
};

export default FsRegisterInitialForm;
